export const DeviceType = {
    mobile: 1,
    tablet: 2,
    desktop: 3,
    other: 4
}

export const DevicePlatform = {
    windows: 1,
    macos: 2,
    ios: 3,
    android: 4,
    other: 5
}
